import { Button, Card, message, Radio, Space } from "antd";
import React, { useEffect, useState } from "react";
import "./ReviewAnswerModule.css";
import { useNavigate, useParams } from "react-router";
import { AssesmentUrl } from "../../../../Constants/Constants";
import axios from "axios";

const CareerReviewAnswerModule = () => {
  const navigate = useNavigate();

  const { id, assessmentId ,groupId} = useParams();

  const profileDetails = JSON.parse(localStorage.getItem("Profile"));
  const userId = profileDetails.user_id;

  const [reviewData, setReviewData] = useState([]);
  const [seconds, setSeconds] = useState(20);

  // Auto redirect after 20 seconds
  useEffect(() => {
    if (seconds === 0) {
      navigate("/");
      return;
    }

    const timerInterval = setInterval(() => {
      setSeconds((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timerInterval);
  }, [seconds]);

  const formatQuestion = (question) => {
    if (!question) return "";

    let formattedQuestion = question.replace(/\\n\s*([a-zA-Z])\./g, "<br/>$1.");

    formattedQuestion = formattedQuestion.replace(
      /(?:^|\s)([a-z])\./g,
      (match, p1) => {
        return match.replace(p1, p1.toUpperCase());
      }
    );

    formattedQuestion = formattedQuestion.replace(
      /\\n(?!\s*[a-zA-Z]\.)/g,
      "<br/>"
    );

    formattedQuestion = formattedQuestion.replace(/\s*<br\/>\s*/g, "<br/>");

    return formattedQuestion;
  };

  useEffect(() => {
    let reviewAnswersUrl = `${AssesmentUrl}career_dev_review_answers_course`;

    let body = {
      course_id: id,
      assessment_id: assessmentId,
      user_id: userId,
    };

    axios
      .post(reviewAnswersUrl, body)
      .then((res) => {
        console.log(res, "reviewAnswersRes");

        let response = res.data;

        if (response.status === 200) {
          setReviewData(response.review_answers_details);
        } else {
          setReviewData([]);
        }
      })
      .catch((err) => {
        message.error(err.message);
      });
  }, []);

  const handleDashboard = () => {
    navigate(`/`);
  };

  return (
    <div className="reviewModuleMainDiv">
      <div className="timerBox">
        Redirecting to dashboard in <strong>{seconds}</strong> seconds...
      </div>

      <h2 className="reviewAnswerClass">Review Your Answers</h2>
      {reviewData.length !== 0 &&
        reviewData.map((item, index) => {
          // Filter out options with null labels
          const validOptions = item.option?.filter(opt => opt.label !== null) || [];

          return (
            <Card
              key={index}
              className={
                item.isCorrect ? "correctAnswerCard" : "wrongAnswerCard"
              }
            >
              <p
                className={
                  item.isCorrect
                    ? "correctAnswerResultType"
                    : "wrongAnswerResultType"
                }
              >
                {item.isCorrect ? "Correct Answer" : "Incorrect Answer"}
              </p>

              <p
                dangerouslySetInnerHTML={{
                  __html: formatQuestion(item.question),
                }}
              />

              {validOptions.length > 0 ? (
                <Radio.Group
                  value={
                    Array.isArray(item.userAnswer) ? null : item.userAnswer
                  }
                >
                  <Space direction="vertical">
                    {validOptions.map((opt) => {
                      const isUserAnswer = Array.isArray(item.userAnswer)
                        ? item.userAnswer.includes(opt.value)
                        : opt.value === item.userAnswer;
                      const isCorrectAnswer = Array.isArray(item.correctAnswer)
                        ? item.correctAnswer.includes(opt.value)
                        : opt.value === item.correctAnswer;

                      let className = "";
                      if (!item.isCorrect && isUserAnswer)
                        className = "radio-incorrect";
                      if (isCorrectAnswer) className = "radio-green";

                      return (
                        <Radio
                          key={opt.value}
                          value={opt.value}
                          className={className}
                        >
                          {opt.label}
                        </Radio>
                      );
                    })}
                  </Space>
                </Radio.Group>
              ) : (
                <div className="textAnswers">
                  <p>
                    <strong>Your Answer:</strong> {item.userAnswer}
                  </p>
                  <p>
                    <strong>Correct Answer:</strong> {item.correctAnswer}
                  </p>
                </div>
              )}
            </Card>
          );
        })}
      <div className="dashboardCenter">
        <Button className="Button" type="primary" onClick={handleDashboard}>
          Go To Dashboard
        </Button>
      </div>
    </div>
  );
};

export default CareerReviewAnswerModule;